// extracted by mini-css-extract-plugin
export default {"product-card":"AIT4yL","productCard":"AIT4yL","title":"gffs1e"};